import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useAffiliateTrainingSteps() {
  const [affiliateTrainingSteps, setAffiliateTrainingSteps] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.affiliateTrainingSteps.index)
      .then((response) => {
        setAffiliateTrainingSteps(response.data.data);
      });
  }, []);

  return affiliateTrainingSteps;
}
